import React from "react"
import { Jumbotron, HeadNotification } from "../../components"
import OurCampaign from "./OurCampaign"
import Transparency from "./Transparency"
import OurImpact from "./OurImpact"
import OurLocation from "./OurLocation"
import BannerCampaign from "./BannerCampaign"
import bgimage from "../../assets/img/bgimage.png"

function Campaign() {
  return (
    <>
      <Jumbotron bgImage={bgimage}>
        <BannerCampaign />
      </Jumbotron>
      <HeadNotification />
      <OurCampaign />
      <OurImpact />
      <OurLocation />
      <Transparency />
    </>
  )
}

export default Campaign
